import { cn } from "@gettactic/helpers";

// Shared style for the modal's section headings / field labels
// (Description, Request Details, sidebar labels, …). Mona Sans 11px/600,
// uppercase with tight tracking, neutral-600.
const sectionHeading =
  "font-mona font-semibold text-[11px] leading-[15.4px] tracking-[0.55px] uppercase text-neutral-600";

export const classes = {
  sectionHeading,
  label: cn(sectionHeading, "block mb-1.5"),
  value: "font-inter font-semibold text-[14px] text-neutral-1000",
  selectTrigger: cn(
    "flex h-9 w-full items-center border-1 border-neutral-200 hover:border-neutral-300 rounded-brand z-dropdown bg-white justify-between pr-4 focus:ring-0"
  )
};
